export default __webpack_public_path__ + "static/media/join.f6a9e754.jpg";